import { FC } from 'react';

import { TableCell } from '@hh.ru/magritte-ui';

import { useCampaignRowModel } from 'components/CampaignsDashboard/hooks/useCampaignRowModel';

import { CAMPAIGNS_TABLE_COLUMNS_MAP } from 'components/CampaignsDashboard/components/CampaignsTable/columns';
import { CampaignTableCell } from 'components/CampaignsDashboard/components/CampaignsTable/components/CampaignTableCell';
import { getCampaignsTableColumns } from 'components/CampaignsDashboard/utils/utils';

import { DashboardCampaign } from 'store/models/campaignsDashboard';
import { useSelector } from 'store/utils';

export const CampaignsTableRow: FC<{ campaign: DashboardCampaign }> = ({ campaign }) => {
    const campaignsCurrentTab = useSelector(({ campaignsDashboard }) => campaignsDashboard.campaignsCurrentTab);
    const columnsPreset = useSelector((state) => state.campaignsFilters.columnsPreset);

    const columns = getCampaignsTableColumns(columnsPreset);
    const {
        campaignStatistics,
        campaignDetails,
        isStatisticsLoading,
        isDetailsLoading,
        isInsufficientBalance,
        onToggleStatus,
        isStatusToggleLoading,
    } = useCampaignRowModel(campaign);

    return (
        <>
            {columns.map((columnKey) => {
                const { width, stickyLeft } = CAMPAIGNS_TABLE_COLUMNS_MAP[columnKey];

                return (
                    <TableCell
                        key={`${campaignsCurrentTab}-${campaign.id}-${columnKey}`}
                        width={width}
                        stickyLeft={stickyLeft}
                    >
                        <CampaignTableCell
                            columnKey={columnKey}
                            campaign={campaign}
                            campaignStatistics={campaignStatistics}
                            campaignDetails={campaignDetails}
                            isStatisticsLoading={isStatisticsLoading}
                            isDetailsLoading={isDetailsLoading}
                            isStatusToggleLoading={isStatusToggleLoading}
                            onToggleStatus={onToggleStatus}
                            isInsufficientBalance={isInsufficientBalance}
                        />
                    </TableCell>
                );
            })}
        </>
    );
};
